
import React from 'react';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import PolicyAlert from './PolicyAlert';
import DateTimeSelector from './DateTimeSelector';
import { ReschedulePolicy, DateTimeSlot } from '@/types/dashboard';

interface RescheduleFormProps {
  reason: string;
  selectedDate: string;
  selectedTime: string;
  availableSlots: DateTimeSlot[];
  policy: ReschedulePolicy;
  hoursUntilAppointment: number;
  canReschedule: boolean;
  isSubmitting: boolean;
  error: string | null;
  onReasonChange: (reason: string) => void;
  onDateChange: (date: string) => void;
  onTimeChange: (time: string) => void;
}

const RescheduleForm: React.FC<RescheduleFormProps> = ({
  reason,
  selectedDate,
  selectedTime,
  availableSlots,
  policy,
  hoursUntilAppointment,
  canReschedule,
  isSubmitting,
  error,
  onReasonChange,
  onDateChange,
  onTimeChange
}) => {
  return (
    <div className="space-y-4">
      <PolicyAlert
        policy={policy}
        hoursUntilAppointment={hoursUntilAppointment}
        canReschedule={canReschedule}
      />

      <div>
        <Label htmlFor="reschedule-reason">Motivo do reagendamento *</Label>
        <Textarea
          id="reschedule-reason"
          value={reason}
          onChange={(e) => onReasonChange(e.target.value)}
          placeholder="Informe o motivo do reagendamento"
          rows={3}
          className="mt-1"
          disabled={isSubmitting || !canReschedule}
        />
      </div>

      <DateTimeSelector
        selectedDate={selectedDate}
        selectedTime={selectedTime}
        availableSlots={availableSlots}
        isDisabled={isSubmitting || !canReschedule}
        onDateChange={onDateChange}
        onTimeChange={onTimeChange}
      />

      {error && (
        <p className="text-destructive text-sm">{error}</p>
      )}
    </div>
  );
};

export default RescheduleForm;
